
export default class PermissionsService
{
	static async HasAudioVideoPermissions() : Promise<boolean>
	{
        try{
            await navigator.mediaDevices.getUserMedia({ audio: true, video: true })
            return true
        }catch(e){
            console.error(e)
        }
        return false
	}

	static async HasAudioPermissions() : Promise<boolean>
	{
        try{
            await navigator.mediaDevices.getUserMedia({ audio: true })
            return true
        }catch(e){
            console.error(e)
        }
        return false
	}

	static async HasVideoPermissions() : Promise<boolean>
	{
        try{
            await navigator.mediaDevices.getUserMedia({ video: true })
            return true
        }catch(e){
            console.error(e)
        }
        return false
	}
}